import React from "react";
import { useTranslation } from "react-i18next";
import { Select, Alert } from "antd";

import { opcionesPeriodicidad } from "../../periodicidad";

export function Step4Periodicity({ periodicity, onChange, selectedCount }) {
  const { t } = useTranslation("rooms");

  // El valor que se guarda sigue siendo la palabra castellana; solo cambia la
  // etiqueta. Ver el porque en `periodicidad.js`.
  const options = opcionesPeriodicidad(t);

  return (
    <div className="wizard-step">
      <div className="form-section">
        <div className="label-with-info">
          <h5>{t("asistenteEscena.paso4.titulo")}</h5>
        </div>

        <Alert
          type="info"
          showIcon
          message={t("asistenteEscena.paso4.avisoTitulo")}
          description={t("asistenteEscena.paso4.avisoDescripcion", {
            count: selectedCount,
          })}
          style={{ marginBottom: 12 }}
        />

        <Select
          value={periodicity}
          onChange={onChange}
          options={options}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
}
